import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IJitsiSettings } from '@common/types';

@Injectable({
  providedIn: 'root'
})
export class JitsiService {
  constructor(private readonly http: HttpClient) {}

  getToken(): Observable<IJitsiSettings> {
    return this.http.get<IJitsiSettings>('api/jitsi');
  }
}
